const LightboxUiLockActions = {
    SHOW_ACTION: 'SHOW_ACTION',
    HIDE_ACTION: 'HIDE_ACTION',
    LOADING_DONE_ACTION: 'LOADING_DONE_ACTION',
};

export { LightboxUiLockActions };